module.exports = __webpack_public_path__ + "img/case_management.65079913.png";